import deLocale from 'apexcharts/dist/locales/de.json';
import enLocale from 'apexcharts/dist/locales/en.json';
import { currentLanguage } from './translator';

/**
 * ApexCharts has its own locale registry — a chart's built-in formatters
 * (tooltip.x.format, xaxis.labels.format, …) resolve month/weekday names
 * from Apex.locales / Apex.defaultLocale, not from date-fns. This helper
 * returns the Apex locale name (short code) for a given app language.
 * gsw_CH falls back to German, mirroring getDateFnsLocale.
 */
export function getApexLocaleName(locale?: string): string {
  switch (locale || currentLanguage) {
    case 'de_CH':
    case 'de_DE':
    case 'gsw_CH':
      return 'de';
    case 'en_US':
      return 'en';
    default:
      return 'en';
  }
}

export const APEX_LOCALES = [deLocale, enLocale];
